/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_appsync_graphqlEndpoint": "https://dge2fldn7fgs3ozms6shn3clqq.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-pwxeq4lrzvbfnarmoe3nb5udke",
    "aws_cloud_logic_custom": [
        {
            "name": "mobRestAPI",
            "endpoint": "https://qcjj7cgmk7.execute-api.eu-west-1.amazonaws.com/master",
            "region": "eu-west-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-1:2fab8a3c-d832-41d5-afd5-3f469c3995e3",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_JIW6Eyefn",
    "aws_user_pools_web_client_id": "1nemt7tt386b90o816ohq0j0io",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
